export const WaterInfoImageType = {
  AppHeader: 'app-header',
  Map: 'map',
  Location: 'location',
  AmbiancePoster: 'ambiance-poster',
} as const;
export type WaterInfoImageType = (typeof WaterInfoImageType)[keyof typeof WaterInfoImageType];

export const WaterCollectionImageType = {
  Hotspots: 'hotspots',
  ContentBlocks: 'content-blocks',
} as const;
export type WaterCollectionImageType = (typeof WaterCollectionImageType)[keyof typeof WaterCollectionImageType];
